import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const HomeHero = ({ campaign = false }) => (
  <section className="relative overflow-hidden bg-slate-900 text-white" data-testid="hero-section">
    <div
      className="absolute inset-0 opacity-10"
      style={{
        backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/41d20fa1-ee12-4f12-94a3-45363f4f073e/images/dabcc4d3f075c4f70f1b991b0d78919e4de455e7f04776f2b668362ab37be4b7.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      aria-hidden="true"
    />
    <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${campaign ? 'py-12 sm:py-14' : 'py-20 sm:py-28'}`}>
      <div className="max-w-3xl">
        <h1 className="text-4xl sm:text-5xl lg:text-5xl font-bold text-white font-['Outfit'] mb-6" data-testid="hero-title">
          Independent Forex & CFD Broker Reviews
        </h1>
        <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-8 max-w-2xl" data-testid="hero-description">
          Compare regulation, fees, platforms and risk profiles across leading global brokers. Make informed decisions with our objective, research-based analysis.
        </p>
        <div className="flex flex-wrap gap-3">
          {campaign ? (
            <a href="#broker-comparison" className="inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 h-11 px-6 transition-colors" data-testid="hero-compare-btn">
              Compare Brokers <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </a>
          ) : (
            <Link to="/compare" className="inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 h-11 px-6 transition-colors" data-testid="hero-compare-btn">
              Compare Brokers <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </Link>
          )}
          <Link to={campaign ? '/compare' : '/guides'} className="inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-slate-600 text-slate-200 hover:bg-slate-800 h-11 px-6 transition-colors" data-testid="hero-guides-btn">
            View All Reviews
          </Link>
        </div>
      </div>
    </div>
  </section>
);